module.exports = require("@ember/-internals/views");